import type { FormDataOf } from '../../../../types/templates';
import { macroSacaTuTarjeta } from '..';

type FormData = FormDataOf<typeof macroSacaTuTarjeta>;

export const getFileNaming = (formData: FormData): string | undefined => {
  const { stage, variant, adChannel } = formData;
  if (!stage || !variant || !adChannel) return undefined;

  const channelCapitalized = adChannel.charAt(0).toUpperCase() + adChannel.slice(1);
  return `${stage}_Mot_${variant}_${channelCapitalized}`;
};
